import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import {
  Chip,
  CircularProgress,
  FormHelperText,
  Select,
  Typography,
} from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { CountryRegionData } from "react-country-region-selector";
import {
  ADD_MYDEALER_USER,
  GET_ALL_USER_DATA,
  getAllDealerOptions,
  getAllSalesOptions,
  UPDATE_DEALER_SALES_ASSIGN,
} from "queries";
import { Mutation, Query } from "react-apollo";
import { toast } from "react-toastify";
import useForm from "components/useForm";
import auth from "Auth";
import axios from "axios";
import auth0User from "components/Auth0User";
import { useQuery } from "@apollo/client";
import "./AddSalesRep.scss";
import {
  DEALER_ASSIGN,
  GET_ASSIGNED_DEALERS_BY_REGION,
} from "pages/Sales/queries";
import InputLabel from "@material-ui/core/InputLabel";
import SalesAssignModal from "components/SalesAssignModal";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: "2em",
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    width: "100%",
    margin: "1em",
    textAlign: "center",
  },
  dense: {
    marginTop: 19,
  },
  formControl: {
    margin: theme.spacing(3),
    marginTop: theme.spacing(3),
  },
  addDealer: {
    width: "200px",
    fontSize: "18px",
    fontWeight: "300",
    textTransform: "uppercase",
    textAlign: "center",
  },
  addDealerBtn: {
    width: "200px",
    padding: "1em",
    fontSize: "14px",
  },
  checkBoxTitle: {
    fontSize: "18px",
    textTransform: "uppercase",
    color: "#1f3340",
    fontWeight: "300",
  },
  formControl: {
    minWidth: "120px",
    maxWidth: "100%",
    // borderRadius: "5px",
    margin: "1em",
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  noLabel: {
    border: "1px solid #666",
  },
  menuPaper: {
    maxHeight: 300,
  },
}));

const AddSalesRep = (props) => {
  const { values, handleChange, resetState, handleChangeCheckbox } =
    useForm(submitForm);
  const classes = useStyles();
  const [isSubmit, setIsSubmit] = useState(false);
  const [regions, setRegions] = useState();
  const [selectedField, setSelectedField] = useState([]);
  const [isError, setError] = useState(false);
  const [matchRegion, setMatchRegion] = useState([]);
  const [open, setOpen] = useState(false);

  const {
    loading: dealerLoading,
    data: dealerData,
    refetch,
  } = useQuery(getAllDealerOptions, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  useEffect(() => {
    if (selectedField.length > 0) {
      salesAssignRefetch({ regions: selectedField });
    }
  }, [selectedField]);

  const {
    loading: salesAssignLoading,
    data: salesAssignData,
    error: salesAssignEror,
    refetch: salesAssignRefetch,
  } = useQuery(GET_ASSIGNED_DEALERS_BY_REGION, {
    variables: { regions: selectedField },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  const {
    loading: salesLoading,
    data: salesData,
    refetch: salesRefetch,
  } = useQuery(getAllSalesOptions, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: "cache-and-network",
  });

  // const getRegions = (country) => {
  // if (!values?.country) {
  //   return [];
  // }
  useEffect(() => {
    let parts = values?.country?.split(",")?.slice(2);
    let result = parts?.join(",");
    setRegions(
      result?.split("|")?.map((regionPair) => {
        let [regionName, regionShortCode = null] = regionPair.split("~");
        return regionName;
      })
    );
  }, [values?.country]);

  // };

  function submitForm() {
    //console.log(values);
  }

  function permissionsCreator() {
    let permissionsArray = ["sales:SALES_ALL"];
    return permissionsArray;
  }

  const collectData = dealerData?.profiles?.filter((item) => {
    return selectedField?.some(
      (region) => region?.toLowerCase() === item?.region?.toLowerCase()
    );
  });

  function createNewUser(data, callBackMutation, dealerAssign, updateDealer) {
    setIsSubmit(true);
    let formData = {};
    let accessTokenPromise = auth0User.getToken();
    let AUTH_API_URL = auth0User.AUTH_API_URL();
    accessTokenPromise
      .then((accessToken) => {
        formData.name = data?.name;
        formData.email = data?.email?.toLowerCase();
        formData.company = data?.company;
        formData.address = data?.address;
        formData.address2 = data?.address2;
        formData.city = data?.city;
        formData.phone = data?.phone;
        formData.has_skiff = data?.has_skiff;
        formData.has_funchaser = data?.has_funchaser;
        formData.has_seachaser = data?.has_seachaser;
        formData.business_email = data?.business_email;
        formData.region = data?.region;
        formData.zipcode = data?.zipcode;
        formData.password = data?.password;
        formData.country = data?.country?.split(",")?.[0];
        formData.role = "Sales";
        formData.parent_admin = auth.getSub();
        formData.assign_region = JSON.stringify(selectedField);
        axios
          .get(`https://maps.googleapis.com/maps/api/geocode/json`, {
            params: {
              address:
                values?.address +
                " " +
                values?.city +
                " " +
                values?.region +
                "," +
                values?.country[0] +
                " " +
                values?.zipcode,
              key: process.env.REACT_APP_GOOGLE_API_KEY,
            },
          })
          .then(function (response) {
            const { lat, lng } =
              response?.data?.results?.[0]?.geometry?.location;
            formData.location =
              '{ "type": "Point", "coordinates": [' + lng + ", " + lat + "] }";

            axios({
              url: AUTH_API_URL + "users-by-email",
              method: "get",
              headers: { Authorization: `Bearer ${accessToken}` },
              params: {
                email: formData?.email,
              },
            })
              .then(function (response) {
                // console.log("REsponse from email");
                // console.log(response);

                if (
                  response?.data !== undefined ||
                  response?.data?.length === 0
                ) {
                  // console.log(response?.data?.length + " Data length");
                  let auth0permissions = permissionsCreator();

                  axios({
                    url: AUTH_API_URL + "users",
                    method: "post",
                    headers: { Authorization: `Bearer ${accessToken}` },
                    data: {
                      connection: "Username-Password-Authentication",
                      email: formData?.email,
                      name: formData?.name,
                      password: data?.password,
                      user_metadata: {
                        full_name: formData?.name,
                      },
                      email_verified: false,
                      app_metadata: {
                        role: "Sales",
                        permissions: auth0permissions,
                      },
                    },
                  })
                    .then(function (response) {
                      // console.log("New User Response ");
                      // console.log(response);

                      let user_id = response?.data?.user_id;
                      let permissions = permissionsCreator();
                      formData.permissions = permissions;
                      formData.profile_id = user_id;

                      // console.log("Calling Data");
                      // console.log(formData);

                      delete data?.password;
                      delete data?.lastname;
                      delete data?.firstname;
                      delete data?.error;
                      delete formData?.password;

                      callBackMutation({
                        variables: {
                          objects: [formData],
                        },
                      }).then(() => {
                        const collectDataWithUnassign =
                          dealerData?.profiles?.filter((item) => {
                            return (
                              selectedField?.some(
                                (region) =>
                                  region?.toLowerCase() ===
                                  item?.region?.toLowerCase()
                              ) && item?.is_sales_assign === false
                            );
                          });
                        const assignData = collectDataWithUnassign?.map(
                          (res) => ({
                            profile_id: user_id,
                            assign_user_id: res?.profile_id,
                             regions: res?.region,
                          })
                        );
                        dealerAssign({
                          variables: {
                            objects: assignData,
                          },
                        }).then(() => {
                          updateDealer({
                            variables: {
                              profile_ids: assignData?.map(
                                (res) => res?.assign_user_id
                              ),
                              is_sales_assign: true,
                              // assign_region: JSON.stringify(selectedField),
                            },
                          }).then(() => {
                            reloads();
                            completedAdd();
                          });
                        });
                      });
                      return true;
                    })
                    .catch(function (error) {
                      toast.error("ERROR: User already exists" + error, {
                        position: toast.POSITION.TOP_RIGHT,
                      });
                      setIsSubmit(false);
                      // console.log(error);
                    });
                }
                // console.log(error, "ERROR: User already exists");
              })
              .catch(function (error) {
                // console.log(error, "error");
                toast.error("ERROR: User already exists", {
                  position: toast.POSITION.TOP_RIGHT,
                });
                setIsSubmit(false);
              });
          })
          .catch((error) => {
            toast.error(
              "Error from getToken() with async( When promise gets rejected ): " +
                error,
              {
                position: toast.POSITION.TOP_RIGHT,
              }
            );
            setIsSubmit(false);
          });
        return true;
      })
      .catch(function (error) {
        console.log(error,"rrrrrrrrrr")
        toast.error("Error Getting GEO Location For Address: " + error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsSubmit(false);
        console.log(error, "errors");
      });
  }

  function validatePassword() {
    if (values?.password !== values?.repassword) {
      //   values?.setCustomValidity("Passwords Don't Match");
    } else {
      //  values?.repassword.setCustomValidity('');
    }
  }

  function completedAdd(payload) {
    setSelectedField([]);
    setError(false);
    setMatchRegion([]);
    setOpen(false);
    setIsSubmit(false);
    toast("New Sales Rep has been created succesfully");
    resetState();
  }

  function reloads() {
    refetch();
    salesRefetch();
    setOpen(false);
  }

  const handleFieldChangeMultiple = (event) => {
    const { value } = event.target;
    setSelectedField(typeof value === "string" ? value.split(",") : value);
    setError(false);
  };
  return (
    <>
      {matchRegion?.length > 0 && (
        <SalesAssignModal
          region={matchRegion}
          open={open}
          setOpen={setOpen}
          collectData={collectData}
          reloads={reloads}
          salesAssignData={salesAssignData?.sales_assign}
        />
      )}
      {dealerLoading ? (
        <CircularProgress />
      ) : (
        <Mutation
          mutation={UPDATE_DEALER_SALES_ASSIGN}
          onError={() => setIsSubmit(false)}
        >
          {(updateDealer, { data, loading, called, error }) => {
            if (error) {
              toast.error(error?.graphQLErrors?.[0]?.message);
            }
            return (
              <Mutation
                mutation={ADD_MYDEALER_USER}
                onError={() => setIsSubmit(false)}
              >
                {(addNewDealerUser, { data, loading, called, error }) => {
                  if (error) {
                    if (error) {
                      toast.error(error?.graphQLErrors?.[0]?.message);
                    }
                  }
                  return (
                    <Mutation
                      mutation={DEALER_ASSIGN}
                      onError={() => setIsSubmit(false)}
                    >
                      {(dealerAssign, { data, loading, called, error }) => {
                        if (error) {
                          toast.error(error?.graphQLErrors?.[0]?.message);
                        }
                        return (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              if (selectedField?.length === 0) {
                                setError(true);
                              } else {
                                const matchedRegions = Array.from(
                                  new Set(
                                    salesData?.profiles
                                      ?.filter((item) => {
                                        try {
                                          const regionArray = JSON.parse(
                                            item?.assign_region
                                          );
                                          return regionArray?.some((region) =>
                                            selectedField?.includes(region)
                                          );
                                        } catch (error) {
                                          console.error(
                                            "Invalid region format:",
                                            item?.region
                                          );
                                          return false;
                                        }
                                      })
                                      ?.map((item) => ({
                                        matchRegion: JSON.parse(
                                          item?.assign_region
                                        )?.filter((region) =>
                                          selectedField?.includes(region)
                                        ),
                                        name: item?.name,
                                        profile_id: item?.profile_id,
                                        region: JSON.parse(item?.assign_region),
                                      }))
                                  )
                                );
                                console.log("Matched Regions:", matchedRegions);
                                console.log(selectedField);
                                if (matchedRegions?.length > 0) {
                                  setMatchRegion(matchedRegions);
                                  setOpen(true);
                                } else {
                                  createNewUser(
                                    values,
                                    addNewDealerUser,
                                    dealerAssign,
                                    updateDealer
                                  );
                                }
                              }
                              return false;
                            }}
                            className={classes.container}
                            autoComplete="off"
                          >
                            <Typography
                              gutterBottom
                              variant="h2"
                              className={classes.addDealer}
                            >
                              Add New Sales Rep
                            </Typography>

                            <Grid
                              container
                              direction="row"
                              justify="space-between"
                              alignItems="center"
                            >
                              <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                                wrap="nowrap"
                              >
                                <TextField
                                  id="email"
                                  name="email"
                                  label="Email"
                                  type="email"
                                  placeholder=""
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.email || ""}
                                  required
                                  variant="outlined"
                                />
                                <TextField
                                  id="business_email"
                                  name="business_email"
                                  label="Business Email"
                                  type="email"
                                  placeholder=""
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.business_email || ""}
                                  variant="outlined"
                                />
                                <TextField
                                  id="password"
                                  name="password"
                                  label="Password"
                                  placeholder="Password"
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.password || ""}
                                  required
                                  type="password"
                                  variant="outlined"
                                  inputProps={{
                                    pattern: ".{8,}",
                                  }}
                                  style={{
                                    // position: "absolute",
                                    bottom: "-9px",
                                    width: "100%",
                                  }}
                                  helperText="Enter 8 Characters Secure Password"
                                />
                              </Grid>
                              <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                                wrap="nowrap"
                              >
                                <TextField
                                  id="name"
                                  name="name"
                                  label="Full Name"
                                  placeholder="Full Name"
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.name || ""}
                                  required
                                  variant="outlined"
                                />
                                <TextField
                                  id="phone"
                                  name="phone"
                                  label="Phone"
                                  placeholder="Phone"
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "phone")}
                                  value={values?.phone || ""}
                                  variant="outlined"
                                />
                                <TextField
                                  id="company"
                                  name="company"
                                  label="Company Name"
                                  placeholder="Company Name"
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.company || ""}
                                  required
                                  variant="outlined"
                                />
                              </Grid>
                              <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                                wrap="nowrap"
                              >
                                <TextField
                                  id="address"
                                  name="address"
                                  label="Address"
                                  placeholder="Address"
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.address || ""}
                                  required
                                  variant="outlined"
                                />
                                <TextField
                                  id="address2"
                                  name="address2"
                                  label="SUITE , APT # , Optional"
                                  placeholder="SUITE , APT # , Optional"
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.address2 || ""}
                                  variant="outlined"
                                />
                                <TextField
                                  id="city"
                                  name="city"
                                  label="City"
                                  placeholder="City"
                                  className={classes.textField}
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.city || ""}
                                  required
                                  variant="outlined"
                                />
                              </Grid>
                              <Grid
                                container
                                direction="row"
                                justify="space-between"
                                alignItems="center"
                                wrap="nowrap"
                              >
                                <TextField
                                  required
                                  id="country"
                                  name="country"
                                  label="Country"
                                  value={values?.country || ""}
                                  select
                                  onChange={(e) => {
                                    setRegions();
                                    handleChange(e);
                                  }}
                                  className={classes.textField}
                                  inputProps={{
                                    name: "country",
                                    id: "country",
                                  }}
                                  variant="outlined"
                                  SelectProps={{
                                    native: true,
                                    MenuProps: {
                                      className: classes.menu,
                                    },
                                  }}
                                >
                                  <option key="" value="" />
                                  {CountryRegionData.map((option, index) => (
                                    <option key={option[0]} value={option}>
                                      {option[0]}
                                    </option>
                                  ))}
                                </TextField>

                                <TextField
                                  required
                                  id="region"
                                  name="region"
                                  label="Region"
                                  value={values?.region || ""}
                                  select
                                  className={classes.textField}
                                  SelectProps={{
                                    native: true,
                                    MenuProps: {
                                      className: classes.menu,
                                    },
                                  }}
                                  onChange={handleChange}
                                  variant="outlined"
                                >
                                  <option key="" value="" />
                                  {regions?.map((option, index) => (
                                    <option key={option[0]} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </TextField>

                                <TextField
                                  id="zipcode"
                                  name="zipcode"
                                  label="Zipcode"
                                  placeholder="Zipcode"
                                  margin="normal"
                                  onChange={(e) => handleChange(e, "text")}
                                  value={values?.zipcode || ""}
                                  required
                                  className={classes.textField}
                                  variant="outlined"
                                >
                                  <MenuItem>
                                    <em>None</em>
                                  </MenuItem>
                                </TextField>
                              </Grid>
                              <Grid
                                container
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                wrap="nowrap"
                              >
                                <FormControl
                                  required
                                  variant="outlined"
                                  className={classes.formControl}
                                  error={error}
                                >
                                  <InputLabel id="mutiple-chip-label">
                                    Assign Region
                                  </InputLabel>
                                  <Select
                                    className="multi-selecter"
                                    labelId="mutiple-chip-label"
                                    id="mutiple-chip-select"
                                    multiple
                                    value={selectedField}
                                    onChange={handleFieldChangeMultiple}
                                    renderValue={(selected) =>
                                      selected.join(", ")
                                    }
                                    MenuProps={{
                                      classes: {
                                        paper: classes.menuPaper,
                                      },
                                    }}
                                  >
                                    {regions?.map((option) => (
                                      <MenuItem key={option[0]} value={option}>
                                        {option}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                  {isError && (
                                    <FormHelperText style={{ color: "red" }}>
                                      Please select at least one region
                                    </FormHelperText>
                                  )}
                                </FormControl>
                              </Grid>

                              <Grid
                                item
                                xs={6}
                                align="left"
                                className="marginborder"
                              >
                                <FormControl
                                  required
                                  component="fieldset"
                                  className={classes.formControl}
                                >
                                  <Typography className={classes.checkBoxTitle}>
                                    BRANDS CARRIED
                                  </Typography>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="has_skiff"
                                          checked={values?.has_skiff || false}
                                          onChange={handleChangeCheckbox}
                                          value="has_skiff"
                                        />
                                      }
                                      label="CAROLINA SKIFF"
                                    />
                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="has_funchaser"
                                          checked={
                                            values?.has_funchaser || false
                                          }
                                          onChange={handleChangeCheckbox}
                                          value="has_funchaser"
                                        />
                                      }
                                      label="FUN CHASER"
                                    />

                                    <FormControlLabel
                                      control={
                                        <Checkbox
                                          name="has_seachaser"
                                          checked={
                                            values?.has_seachaser || false
                                          }
                                          onChange={handleChangeCheckbox}
                                          value="has_seachaser"
                                        />
                                      }
                                      label="SEA CHASER"
                                    />
                                  </FormGroup>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} align="center">
                                <Button
                                  variant="contained"
                                  color="primary"
                                  className={classes.addDealerBtn}
                                  type="submit"
                                  disabled={isSubmit}
                                >
                                  ADD SALES REP
                                </Button>
                              </Grid>
                            </Grid>
                          </form>
                        );
                      }}
                    </Mutation>
                  );
                }}
              </Mutation>
            );
          }}
        </Mutation>
      )}
    </>
  );
};

export default AddSalesRep;
